import { defineMessages } from 'react-intl';

const previewCardMessages: {
	readonly loadingLabel: {
		readonly id: 'ai-mate.preview-card.loading-label';
		readonly defaultMessage: 'Loading {label}';
		readonly description: 'Accessible label announced by screen readers when content is being loaded';
	};
} = defineMessages({
	loadingLabel: {
		id: 'ai-mate.preview-card.loading-label',
		defaultMessage: 'Loading {label}',
		description: 'Accessible label announced by screen readers when content is being loaded',
	},
} as const);

export default previewCardMessages;
